import { render } from "./OrdersProduct.vue?vue&type=template&id=052458e6&scoped=true"
import script from "./OrdersProduct.vue?vue&type=script&lang=js"
export * from "./OrdersProduct.vue?vue&type=script&lang=js"

import "./OrdersProduct.vue?vue&type=style&index=0&id=052458e6&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052458e6"]])

export default __exports__